import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const AOSProvider = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,  // how long each animation runs
      once: false,     // 👈 allow animations every time
      mirror: true,    // 👈 replay when scrolling back up
    });

    // ✅ refresh AOS when scrolling or resizing
    const interval = setInterval(() => {
      AOS.refresh();
    }, 1000); // every 1s

    return () => clearInterval(interval);
  }, []);

  return null; // nothing visual to render
};

export default AOSProvider;
